var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'default': _vm.showBg
    },
    attrs: {
      "id": "poster"
    }
  }, [!_vm.showBg ? _c('div', {
    staticClass: "poster_container"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/capusta-logo-colored-special-compressed.svg"),
      "alt": "capusta_logo"
    },
    on: {
      "click": function click($event) {
        return _vm.$openLink(_vm.LANDING_URL);
      }
    }
  }), _vm._t("text")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }